<template>
  <div>
    <wss-player v-if="stream!==null"
                style="background: #000;height: 100%;"
                :stream="stream"
                @reconnect="reconnect"
                @capture-picture="capturePicture"/>
<!--    <ysy-player :eqtId="device"></ysy-player>-->
  </div>
</template>

<script>
import WssPlayer from "@/components/player/WssPlayer.vue";
import YsyPlayer from "@/components/player/YsyPlayer.vue";
import { getHikStreamVO, listDevice } from "@/api/hik";

const {JSPlugin} = window;

export default {
  name: 'DevicePlayer',
  components: {YsyPlayer, WssPlayer},
  data() {
    return {
      stream: null,
      range: null,
      device: null,
      cameraIndexCode: '',
      deviceList:[]
    }
  },
  watch: {},
  computed: {},
  created() {
    this.device = this.$route.params.device
    this.range = this.$route.query.range
    console.log({device: this.device, range: this.range})
    this.listDevice()
  },
  mounted() {
    if (this.deviceList.length > 0) {
      this.device = this.deviceList[0];
      this.playHikStream()
    }
  },
  methods: {
    //进入主系统
    async listDevice() {
      this.deviceList = await listDevice()
      if (this.deviceList.length > 0) {
        this.device = this.deviceList[0];
        this.playHikStream()
      }
    },
    // 获取视频播放地址
    async playHikStream() {
      if (!this.device) {
        return;
      }
      try {
        this.stream = await getHikStreamVO(this.device)
      } catch (e) {
        // this.$message.error(e)
      }
      // const {serialNO, cameraIndexCode} = this.deviceMap[this.device]
      // if (this.range) {
      //   const [begin, end] = this.range.split('-')
      //   console.log({begin, end})
      //   const result = await get(`/open/hik-device/playback/${this.cameraIndexCode||cameraIndexCode}/wss/${begin}/${end}`)
      //   console.log(['result', result])
      //   if (result.code === 'A00000') {
      //     if (result.rowCount > 0) {
      //       this.stream = new HikStreamVO({key: serialNO, ...result.data[0]})
      //     } else {
      //       this.stream = null
      //       this.$message.error('执法仪回放录像地址获取失败，请确认设备是否正常注册到平台')
      //     }
      //   } else {
      //     this.stream = null
      //     console.error(`执法仪回放录像地址获取失败：${result.message}`)
      //     this.$message.error(result.message)
      //   }
      // } else {
      //   const result = await get(`/open/hik-device/getUrl/${this.cameraIndexCode||cameraIndexCode}/wss`)
      //   console.log(['result', result])
      //   if (result.code === 'A00000') {
      //     if (result.rowCount > 0) {
      //       this.stream = new HikStreamVO({key: serialNO, protocol: 'wss', url: result.data[0]})
      //     } else {
      //       this.stream = null
      //       this.$message.error('执法仪实时画面播放地址获取失败，请确认设备是否正常注册到平台')
      //     }
      //   } else {
      //     this.stream = null
      //     console.error(`执法仪实时画面播放地址获取失败：${result.message}`)
      //     this.$message.error(result.message)
      //   }
      // }
    },
    // 播放断开重连
    reconnect({key, protocol}) {
      console.log({key, protocol})
      this.playHikStream()
    },
    // 视频截图
    capturePicture(base64) {
      //console.log(base64)
      this.base64Image = base64
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/player/DevicePlayer.vue